module.exports = __webpack_public_path__ + "static/media/under_capacity_normal.d0a3f800.svg";